import React, { useState, useEffect } from 'react'
import AuthLayout from '../../../../layout/AuthLayout'
import { Box, Flex, Text, Button, Group, Pagination, ScrollArea, Modal, TextInput, Drawer, Badge } from '@mantine/core' 
import classes from '../../../../assets/module-css/AdminLayout.module.css'
import { IconPlus } from '@tabler/icons-react'
import { useDispatch } from 'react-redux'
import { updateRoute } from '../../../../store/dataRoute'
import { getAllSourcingRequestList, deleteSourcingRequest } from '../../../../services/sourcing-request'
import { getAllRequestQuoteList } from '../../../../services/request-quote'
import LoadingData from '../../../../component/ui/LoadingData'
import NoData from '../../../../component/ui/NoData'
import TableProductRequest from '../../../../component/pages/ProductRequest/TableProductRequest'
import FormProductRequest from '../../../../component/pages/ProductRequest/FormProductRequest'
import FormUploadImages from '../../../../component/pages/ProductRequest/FormUploadImages'
import FormAttachDocument from '../../../../component/pages/ProductRequest/FormAttachDocument'
import FormSubmitQuote from '../../../../component/pages/ProductRequest/FormSubmitQuote'
import FormSubmitRecommendation from '../../../../component/pages/ProductRequest/FormSubmitRecommendation'
import FormChangeStatus from '../../../../component/pages/ProductRequest/FormChangeStatus'
import ShareLinkProductRequest from '../../../../component/pages/ProductRequest/ShareLinkProductRequest'
import FormFilterRequest from '../../../../component/pages/ProductRequest/FormFilterRequest'
import { modalDeleteData } from '../../../../component/ui/Prompt/modalDeleteData'
import { notificationError } from '../../../../component/ui/Notifications'
import { useNavigate } from 'react-router-dom'
import { useDebouncedCallback } from '@mantine/hooks'

const defaultParameter = {
  'page[num]': 1,
  'page[limit]': 10,
  sort: '-id',
  'fields[user]': 'name',
  'fields[agent]': 'name',
  include: 'images,products,statuses,creator,updater,user,agent,documents,product_seeker',
}

const labelTable = [
  {
    label: 'ID',
    width: 30
  },
  {
    label: 'Request No.',
    width: 150
  },
  {
    label: 'Image',
    width: 100
  },
  {
    label: 'Product Name',
    width: 250
  },
  {
    label: 'Products',
    width: 150
  },
  {
    label: 'Quotes',
    width: 150
  },
  {
    label: 'User',
    width: 170
  },
  {
    label: 'Agent By',
    width: 170
  },
  {
    label: 'Product Seeker',
    width: 170
  },
  {
    label: 'Created By',
    width: 170
  },
  {
    label: 'Updated By',
    width: 170
  },
  {
    label: 'Status',
    width: 170
  },
  {
    label: 'Action',
    width: 50
  },
]

const defaultStatus = [
  {
    value: '82',
    label: 'In Review'
  },
  {
    value: '83',
    label: 'In Progress'
  },
  {
    value: '84',
    label: 'Finished'
  },
  {
    value: '85',
    label: 'Canceled'
  },
]
 
const ProductRequest = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [params, setParams] = useState(defaultParameter)
  const [sourcingRequestList, setSourcingRequestList] = useState([])
  const [totalData, setTotalData] = useState(0)
  const [loading, setLoading] = useState(true)
  const [openModalForm, setOpenModalForm] = useState(false)
  const [openModalUploadImage, setOpenModalUploadImage] = useState(false)
  const [openModalAttachDocument, setOpenModalAttachDocument] = useState(false)
  const [openModalSubmitQuote, setOpenModalSubmitQuote] = useState(false)
  const [openModalSubmitRecommendation, setOpenModalSubmitRecommendation] = useState(false)
  const [openModalChangeStatus, setOpenModalChangeStatus] = useState(false)
  const [openModalShareLink, setOpenModalShareLink] = useState(false)
  const [openModalFilter, setOpenModalFilter] = useState(false)
  const [detailData, setDetailData] = useState(null)

  const mappingRoute = [
    {
      label: '/',
      route: null
    },
    {
      label: 'Request',
      route: null
    },
    {
      label: 'Sourcing Request',
      route: null
    },
  ]

  const handleGetSourcingRequestList = useDebouncedCallback(async () => {
    setLoading(true)
    try {
      const response = await getAllSourcingRequestList(params)
      if (response.success) {
        const dataSourcingRequest = response.data
        const pickIncludedCreator = response.included.creator || []
        const pickIncludedUpdater = response.included.updater || []
        const pickIncludedImages = response.included.images || []
        const pickIncludedProduct = response.included.products || []
        const pickIncludedUser = response.included.user || []
        const pickIncludedAgent = response.included.agent || []
        const pickIncludedStatuses = response.included.statuses || []
        const pickIncludedDocument = response.included.documents || []
        const pickIncludedSeeker = response.included.product_seeker || []

        const countData = response.meta.pagination.total

        const getImage = (setImage) => {
          let dataImage = null
          const getLastId = Math.max(...setImage.map(val => val.id))
          if (getLastId) {
            dataImage = pickIncludedImages[getLastId].attributes.source
          }
          return dataImage
        }

        const getDataUser = (creatorId, included) => {
          let data = null
          const findCreator = included[creatorId]
          if (findCreator) {
            data = {
              id: findCreator.attributes.id,
              name: findCreator.attributes.name
            }
          }
          return data
        }

        const getDataProductSeeker = (userId, included) => {
          let data = null
          const findSeeker = included[userId]
          if (findSeeker) {
            data = {
              id: findSeeker.attributes.id,
              name: findSeeker.attributes.name
            }
          }
          return data
        }

        const getProducts = (dataProducts) => {
          const remapData = dataProducts.map((val) => {
            return {
              id: pickIncludedProduct[val.id].attributes.id,
              title: pickIncludedProduct[val.id].attributes.title,
              image: pickIncludedProduct[val.id].attributes.image,
              regular_price: pickIncludedProduct[val.id].attributes.regular_price,
              original_currency: pickIncludedProduct[val.id].attributes.original_currency,
              quantity: pickIncludedProduct[val.id].attributes.quantity,
              quantity_unit: pickIncludedProduct[val.id].attributes.quantity_unit
            }
          })
          return remapData
        }

        const getStatus = (dataStatus) => {
          const remapData = dataStatus.map((val) => {
            return {
              id: pickIncludedStatuses[val.id].attributes.id,
              name: pickIncludedStatuses[val.id].attributes.name
            }
          })
          return remapData
        }

        const getDocument = (dataDocument) => {
          const remapData = dataDocument.map((val) => {
            return {
              id: pickIncludedDocument[val.id].attributes.id,
              name: pickIncludedDocument[val.id].attributes.name,
              url: pickIncludedDocument[val.id].attributes.url
            }
          })
          return remapData
        }

        const remapData = await Promise.all(dataSourcingRequest.map( async (val) => {
          let dataQuote = []
          const dataRequestQuote = await handleGetDataRequestQuote(val.attributes.id)
          if (dataRequestQuote.success) {
            dataQuote = dataRequestQuote.data
          }
          const dataRelationships = val.relationships
          const dataCreator = dataRelationships.creator
          const dataUpdater = dataRelationships.updater
          const dataImages = dataRelationships.images
          const dataProduct = dataRelationships.products
          const dataStatuses = dataRelationships.statuses
          const dataDocuments = dataRelationships.documents
          const remap = {
            id: val.attributes.id,
            request_number: val.attributes.request_number,
            brand: val.attributes.brand,
            creator: dataCreator ? getDataUser(dataCreator.id, pickIncludedCreator) : null,
            created_at: val.attributes.created_at,
            updater: dataUpdater ? getDataUser(dataUpdater.id, pickIncludedUpdater) : null,
            updated_at: val.attributes.updated_at,
            currency: val.attributes.currency,
            description: val.attributes.description,
            price: val.attributes.price,
            quantity: val.attributes.quantity,
            quantity_unit: val.attributes.quantity_unit,
            title: val.attributes.title,
            products: dataProduct.length > 0 ? getProducts(dataProduct) : [],
            images: dataImages.length > 0 ? getImage(dataImages) :  null,
            status: dataStatuses.length > 0 ? getStatus(dataStatuses) : [],
            submit_quote_status: !!dataQuote.length > 0,
            quote_id: dataQuote,
            user: val.attributes.user_id !== null ? getDataUser(val.attributes.user_id, pickIncludedUser) : null,
            agent: val.attributes.agent_id !== null ? getDataUser(val.attributes.agent_id, pickIncludedAgent) : null,
            signature: val.attributes.signature,
            short_url: val.attributes.short_url,
            url: val.attributes.url,
            documents: dataDocuments.length > 0 ? getDocument(dataDocuments) : [],
            sales_by: val.attributes.sales_by,
            product_seeker: val.attributes.product_seeker_id !== null ? getDataProductSeeker(val.attributes.product_seeker_id, pickIncludedSeeker) : null
          }
          return remap
        }))

        setSourcingRequestList(remapData)
        setTotalData(countData)
      } else {
        setSourcingRequestList([])
        setTotalData(1)
      }
    } catch (error) {
      console.log(error)
      setSourcingRequestList([])
      setTotalData(1)
      const errorMessage = error.response.data.message
      notificationError('Load Data Error', `${errorMessage}`)
    } finally {
      setLoading(false)
    }
  }, 500)

  const handleGetDataRequestQuote = async (requestId) => {
    const params = {
      'filter[product_request_id][is]': requestId,
      include: 'product_request'
    }
    try {
      const response = await getAllRequestQuoteList(params)
      return response
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    dispatch(updateRoute({ 'data': mappingRoute }))
    // eslint-disable-next-line
  }, [dispatch])

  useEffect(() => {
    handleGetSourcingRequestList()
    // eslint-disable-next-line
  }, [params])

  const actions = {
    edit: (val) => {
      setOpenModalForm(true)
      setDetailData(val)
    },
    uploadImage: (val) => {
      setOpenModalUploadImage(true)
      setDetailData(val)
    },
    attachDocument: (val) => {
      setOpenModalAttachDocument(true)
      setDetailData(val)
    },
    submitQuote: (val) => {
      setOpenModalSubmitQuote(true)
      setDetailData(val)
    },
    confirmedQuote: (val) => {
      navigate('/request/sourcing-quote')
    },
    submitRecommendation: (val) => {
      setOpenModalSubmitRecommendation(true)
      setDetailData(val)
    },
    changeStatus: (val) => {
      setOpenModalChangeStatus(true)
      setDetailData(val)
    },
    shareLink: (val) => {
      setOpenModalShareLink(true)
      setDetailData(val)
    },
    delete: (val) => {
      modalDeleteData('sourcing request', val.id, val.request_number, deleteSourcingRequest, handleGetSourcingRequestList)
    }
  }

  const handleAction = (val, type) => {
    return actions[type](val)
  }

  const handleChangeFilter = (name, val) => {
    setParams((oldVal) => ({ ...oldVal, [name]: val}))
  }

  const handleApplyFilter = (params) => {
    setParams((oldVal) => ({ ...oldVal, ...params }))
  }

  const handleChangePage = (val) => {
    // eslint-disable-next-line
    setParams((oldVal) => ({ ...oldVal, ['page[num]']: val }))
  }

  const onCloseModalForm = () => {
    setOpenModalForm(false)
    setDetailData(null)
  }

  const onCloseModalUploadImage = () => {
    setOpenModalUploadImage(false)
    setDetailData(null)
  }

  const onCloseModalAttachDocument = () => {
    setOpenModalAttachDocument(false)
    setDetailData(null)
  }

  const onCloseModalSubmitQuote = () => {
    setOpenModalSubmitQuote(false)
    setDetailData(null)
  }

  const onCloseModalSubmitRecommendation = () => {
    setOpenModalSubmitRecommendation(false)
    setDetailData(null)
  }

  const onCloseModalChangeStatus = () => {
    setOpenModalChangeStatus(false)
    setDetailData(null)
  }
  
  const onCloseModalShareLink = () => {
    setOpenModalShareLink(false)
    setDetailData(null)
    handleGetSourcingRequestList()
  }

  const onCloseFormFilter = () => {
    setOpenModalFilter(false)
  }

  const mappingFilterSourcing = (parameter) => {
    if (parameter['filter[request_number][is]'] || parameter['filter[user_id][is]'] || parameter['filter[agent_id][is]'] || parameter['filter[statuses.id][is]']) {
      return (
        <Box>
          <Group gap='sm' align='center' mb={12}>
            {parameter['filter[request_number][is]'] ? <Badge variant="light" color="black" tt='capitalize' fw='500'>Request Number : {parameter['filter[request_number][is]']}</Badge> : ''}
            {parameter['filter[user_id][is]'] ? <Badge variant="light" color="black" tt='capitalize' fw='500'>User ID : {parameter['filter[user_id][is]']}</Badge> : ''}
            {parameter['filter[agent_id][is]'] ? <Badge variant="light" color="black" tt='capitalize' fw='500'>Agent ID : {parameter['filter[agent_id][is]']}</Badge> : ''}
            {parameter['filter[statuses.id][is]'] ? <Badge variant="light" color="black" tt='capitalize' fw='500'>Status : {defaultStatus.find(val => val.value === parameter['filter[statuses.id][is]']).label}</Badge> : ''}
          </Group>
          <Group align='center' gap='sm'>
            <Button size='compact-sm' fz={11} fw='500' variant="outline" onClick={() => setOpenModalFilter(true)}>Modify Filter</Button>
            <Button size='compact-sm' fz={11} fw='500' variant="outline" onClick={() => setParams(defaultParameter)}>Clear Filter</Button>
          </Group>
        </Box>
      )
    }
  }

  return (
    <AuthLayout>
      <Box my={20}>
        <Box>
          <Flex justify='space-between' align="center" mb={30}>
            <Text className={classes.titleLayout}>Sourcing Request</Text>
            <Group gap='sm' align='center'>
              <TextInput
                value={params['filter[title][like]']}
                placeholder='Search by product name'
                onChange={(val) => {
                  handleChangeFilter('filter[title][like]', val.target.value)
                  handleChangePage(1)
                }}
                size='xs'
              />
              <Button size='xs' variant="outline" onClick={() => setOpenModalFilter(true)}>Filter</Button>
              <Button size='xs' leftSection={<IconPlus size={14} />} onClick={() => setOpenModalForm(true)}>Add Sourcing Request</Button>
            </Group>
          </Flex>
        </Box>
        {mappingFilterSourcing(params)}
        <Box my={30}>
          {loading ? <LoadingData /> : sourcingRequestList.length > 0 ? <TableProductRequest label={labelTable} data={sourcingRequestList} actionMethod={handleAction} /> : <NoData />}
        </Box>
        <Flex justify='end'>
          <Pagination size='sm' onChange={handleChangePage} value={params['page[num]']} total={totalData > 0 ? Math.ceil(totalData / params['page[limit]']) : totalData} />
        </Flex>
      </Box>
      <Drawer position='right' title='Filter Sourcing Request' opened={openModalFilter} onClose={onCloseFormFilter} overlayProps={{ backgroundOpacity: 0.5, blur: 4 }}>
        <FormFilterRequest paramsRequest={params} applyFilter={handleApplyFilter} onClose={onCloseFormFilter} />
      </Drawer>
      <Modal opened={openModalForm} onClose={onCloseModalForm} centered closeOnClickOutside={false} size='xl' title={<Text fw='Bold'>{detailData === null ? 'Add' : 'Update'} Sourcing Request</Text>}  scrollAreaComponent={ScrollArea.Autosize} withCloseButton={false}>
        <FormProductRequest dataSourcingRequest={detailData} onCloseModal={onCloseModalForm} reloadList={handleGetSourcingRequestList} />
      </Modal>
      <Modal opened={openModalUploadImage} onClose={onCloseModalUploadImage} centered closeOnClickOutside={false} size='lg' title={<Text fw='Bold'>Upload Image Sourcing Request</Text>}  scrollAreaComponent={ScrollArea.Autosize} withCloseButton={false}>
        <FormUploadImages dataSourcingRequest={detailData} onCloseModal={onCloseModalUploadImage} reloadList={handleGetSourcingRequestList} />
      </Modal>
      <Modal opened={openModalAttachDocument} onClose={onCloseModalAttachDocument} centered closeOnClickOutside={false} size='lg' title={<Text fw='Bold'>Attach Document</Text>}  scrollAreaComponent={ScrollArea.Autosize} withCloseButton={false}>
        <FormAttachDocument dataSourcingRequest={detailData} onCloseModal={onCloseModalAttachDocument} reloadList={handleGetSourcingRequestList} />
      </Modal>
      <Modal opened={openModalSubmitQuote} onClose={onCloseModalSubmitQuote} centered closeOnClickOutside={false} size='lg' scrollAreaComponent={ScrollArea.Autosize} withCloseButton={false}>
        <FormSubmitQuote dataSourcingRequest={detailData} onCloseModal={onCloseModalSubmitQuote} reloadList={handleGetSourcingRequestList} />
      </Modal>
      <Modal opened={openModalSubmitRecommendation} onClose={onCloseModalSubmitRecommendation} centered closeOnClickOutside={false} size='xl' title={<Text fw='Bold'>Submit Product Recommendation</Text>} scrollAreaComponent={ScrollArea.Autosize} withCloseButton={false}>
        <FormSubmitRecommendation dataSourcingRequest={detailData} onCloseModal={onCloseModalSubmitRecommendation} reloadList={handleGetSourcingRequestList} />
      </Modal>
      <Modal opened={openModalChangeStatus} onClose={onCloseModalChangeStatus} centered closeOnClickOutside={false} size='xl' title={<Text fw='Bold'>Change Status</Text>} scrollAreaComponent={ScrollArea.Autosize} withCloseButton={false}>
        <FormChangeStatus dataSourcingRequest={detailData} onCloseModal={onCloseModalChangeStatus} reloadList={handleGetSourcingRequestList} />
      </Modal>
      <Modal opened={openModalShareLink} onClose={onCloseModalShareLink} centered closeOnClickOutside={false} size='lg' title={<Text fw='Bold'>Share Request Detail #{detailData !== null ? detailData.id : ''} URL</Text>} scrollAreaComponent={ScrollArea.Autosize} withCloseButton={false}>
        <ShareLinkProductRequest dataSourcingRequest={detailData} onCloseModal={onCloseModalShareLink} />
      </Modal>
    </AuthLayout>
  )
}

export default ProductRequest